import React from "react";
// import { Spinner } from "react-bootstrap";
import Head from "./Head";
import Body from "./Body";
import { t } from "../../../utils/i18n";

const Table = ({
  transfers,
  removeTransfer,
  loading,
  canViewCardTransactionDetails,
}) => (
  <div className="px-md-3">
    <div
      className="card mt-3"
      style={{ boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)" }}
    >
      <table className="table table-responsive w-100 d-block d-md-table bg-transparent">
        <Head />
        {loading ? (
          <div className="d-flex justify-content-center align-items-center">
            {t("account.activities.loading")}
          </div>
        ) : (
          <Body
            transfers={transfers}
            removeTransfer={removeTransfer}
            canViewCardTransactionDetails={canViewCardTransactionDetails}
          />
        )}
      </table>
    </div>
  </div>
);

export default Table;
